export const BOOKING_TEAM_ROLES = {
  SALES: 'sales',
  OPERATIONS: 'operations',
  TRAVEL_DESIGNER: 'travel_designer',
  CONCIERGE: 'concierge',
};

export const BOOKING_TEAM_ROLE_LABELS = {
  [BOOKING_TEAM_ROLES.SALES]: 'Sales',
  [BOOKING_TEAM_ROLES.OPERATIONS]: 'Operations',
  [BOOKING_TEAM_ROLES.TRAVEL_DESIGNER]: 'Travel Designer',
  [BOOKING_TEAM_ROLES.CONCIERGE]: 'Concierge',
};
